import React, { useState } from 'react';
import { FloatButton, Drawer, List, Typography } from 'antd';
import {
  PlusOutlined,
  AccountBookOutlined,
  CreditCardOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  SwapOutlined,
  UserSwitchOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import './QuickAddFab.css';

/**
 * Botão flutuante (+) no mobile → action sheet Conta / Cartão / Milhas.
 */
const QuickAddFab = ({
  temModuloFinanceiro,
  temModuloMilhas,
  onOpenTransacao,
  onOpenCartao,
  onOpenEntradaMilhas,
  onOpenSaidaMilhas,
  onOpenTransfProgramas,
  onOpenTransfPessoas,
  canPromptInstall = false,
  onInstallApp,
  onShowIosGuide,
  isIosSafari = false,
}) => {
  const [open, setOpen] = useState(false);

  const showFab = temModuloFinanceiro || temModuloMilhas;
  if (!showFab) return null;

  const sections = [];

  if (temModuloFinanceiro) {
    sections.push({
      key: 'financeiro',
      title: 'Financeiro',
      items: [
        {
          key: 'conta',
          title: 'Lançamento financeiro',
          description: 'Conta corrente / poupança',
          icon: <AccountBookOutlined style={{ fontSize: 20, color: '#1F4F4F' }} />,
          onClick: () => {
            setOpen(false);
            onOpenTransacao?.();
          },
        },
        {
          key: 'cartao',
          title: 'Despesa no cartão',
          description: 'Lançar na fatura',
          icon: <CreditCardOutlined style={{ fontSize: 20, color: '#1F4F4F' }} />,
          onClick: () => {
            setOpen(false);
            onOpenCartao?.();
          },
        },
      ],
    });
  }

  if (temModuloMilhas) {
    sections.push({
      key: 'milhas',
      title: 'Milhas',
      items: [
        {
          key: 'entrada-milhas',
          title: 'Nova Entrada',
          description: 'Crédito de milhas / pontos',
          icon: <ArrowUpOutlined style={{ fontSize: 20, color: '#1F4F4F' }} />,
          onClick: () => {
            setOpen(false);
            onOpenEntradaMilhas?.();
          },
        },
        {
          key: 'saida-milhas',
          title: 'Nova Saída',
          description: 'Débito, emissão ou venda',
          icon: <ArrowDownOutlined style={{ fontSize: 20, color: '#1F4F4F' }} />,
          onClick: () => {
            setOpen(false);
            onOpenSaidaMilhas?.();
          },
        },
        {
          key: 'transf-programas',
          title: 'Transf. Programas',
          description: 'Entre programas de fidelidade',
          icon: <SwapOutlined style={{ fontSize: 20, color: '#1F4F4F' }} />,
          onClick: () => {
            setOpen(false);
            onOpenTransfProgramas?.();
          },
        },
        {
          key: 'transf-pessoas',
          title: 'Transf. Pessoas',
          description: 'Entre portadores',
          icon: <UserSwitchOutlined style={{ fontSize: 20, color: '#1F4F4F' }} />,
          onClick: () => {
            setOpen(false);
            onOpenTransfPessoas?.();
          },
        },
      ],
    });
  }

  const installItems = [];
  if (canPromptInstall) {
    installItems.push({
      key: 'install',
      title: 'Instalar app',
      description: 'Atalho na tela inicial',
      icon: <DownloadOutlined style={{ fontSize: 20, color: '#B89040' }} />,
      onClick: () => {
        setOpen(false);
        onInstallApp?.();
      },
    });
  } else if (isIosSafari) {
    installItems.push({
      key: 'install-ios',
      title: 'Instalar na tela inicial',
      description: 'Ver como instalar no iPhone',
      icon: <DownloadOutlined style={{ fontSize: 20, color: '#B89040' }} />,
      onClick: () => {
        setOpen(false);
        onShowIosGuide?.();
      },
    });
  }

  const renderItem = (item) => (
    <List.Item
      key={item.key}
      className="quick-add-sheet__item"
      onClick={item.onClick}
      style={{ cursor: 'pointer', padding: '12px 4px' }}
    >
      <List.Item.Meta
        avatar={item.icon}
        title={<Typography.Text strong style={{ fontSize: 16 }}>{item.title}</Typography.Text>}
        description={item.description}
      />
    </List.Item>
  );

  return (
    <>
      <FloatButton
        type="primary"
        icon={<PlusOutlined />}
        className="quick-add-fab"
        aria-label="Adicionar lançamento"
        onClick={() => setOpen(true)}
      />
      <Drawer
        title="Adicionar lançamento"
        placement="bottom"
        height="auto"
        open={open}
        onClose={() => setOpen(false)}
        className="quick-add-sheet"
        styles={{
          body: { paddingTop: 8, paddingBottom: 'calc(16px + env(safe-area-inset-bottom, 0px))' },
        }}
      >
        {sections.map((section) => (
          <div key={section.key} className="quick-add-sheet__section">
            <Typography.Text className="quick-add-sheet__section-title" type="secondary">
              {section.title}
            </Typography.Text>
            <List dataSource={section.items} split={false} renderItem={renderItem} />
          </div>
        ))}
        {installItems.length > 0 && (
          <div className="quick-add-sheet__section">
            <List dataSource={installItems} split={false} renderItem={renderItem} />
          </div>
        )}
      </Drawer>
    </>
  );
};

export default QuickAddFab;
